module.exports = __webpack_public_path__ + "edf61135b0ab02c8348dd704c31cac35.png";